export default __webpack_public_path__ + "static/media/farm_light.492feec6.png";